import React, { ReactElement } from 'react'

export default function OneLineHeader(): ReactElement {
  return (
    <header>
      <h1>One Line Header</h1>
    </header>
  )
}
